import { BaseEntity } from '../base/BaseEntity'
import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { AdjustmentItem } from './AdjustmentItem'
import type { AdjustmentStatusEnum } from './AdjustmentStatusEnum'
import { InventoryBySerialNumber } from '../inventorybyserialnumber/InventoryBySerialNumber'
import { Activity } from '../activity/Activity'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@modelOptions({ schemaOptions: { timestamps: true } })
@InputType('AdjustmentInput')
export class Adjustment extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('adj') })
  declare _id: string

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  completionDate: Date

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  cancellationDate: Date

  @Field(() => [AdjustmentItem])
  @Prop({ type: [AdjustmentItem] })
  items: AdjustmentItem[]

  @Field(() => String)
  @Prop({ type: String })
  declare status: AdjustmentStatusEnum

  @Field(() => [Activity])
  @Prop({ type: [Activity] })
  remarksActivity: Activity[]

  /**
   * @description
   * This is a computed field that returns the list of inventory serial numbers
   * associated with the adjustment.
   */
  @Field(() => [InventoryBySerialNumber])
  inventorySerialNumbers: ReturnType<() => InventoryBySerialNumber[]>
}
